import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ThankYouPage from "../pages/thankyou/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/obrigado",
    element: <ThankYouPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;